<script lang="ts">
	import { onMount, createEventDispatcher } from "svelte";
	import Options from "./Options.svelte";
	import { Timer } from "./utils";

	export let optionsPayGrade: Array<string> = [];
	// export let optionsRank: Array<string> = [];
	export let optionsComponent: Array<string> = [];

	onMount(() => {
		return () =>
			// @ts-ignore
			jQuery(".datepicker-input").each(() => {
				// @ts-ignore
				jQuery(this).data("datepicker").destroy();
			});
	});

	const searchTimer: Timer = new Timer(700);
	const dispatch = createEventDispatcher();

	let searchValue: string = "";
	let payGradeValue: string = "";
	let rankValue: string = "";
	let componentValue: string = "";

	let yearBirthValue: string = "";
	let yearDeathValue: string = "";
	let yearEntryValue: string = "";
	let yearDischargeValue: string = "";

	let showAdvanced: boolean = false;

	function onFilter(key: string, value: string) {
		console.log(key);

		dispatch("change", { key, value });
	}

	function datepicker() {
		// Using Air Datepicker
		// Would rather not use this, but there's not much choice ATM
		// @ts-ignore
		const $this = jQuery(this);

		if ($this.data("datepicker") === undefined) {
			// @ts-ignore
			$this.datepicker({
				language: "en",
				view: "years",
				minView: "years",
				dateFormat: "yyyy",
				onSelect: function (formattedDate, date, instance) {
					// causes Svelte to update it's bindings
					instance.el.dispatchEvent(new Event("input"));
					// Fires change so filters update
					instance.el.dispatchEvent(new Event("change"));
				},
			});
		}

		$this.data("datepicker").show();
	}

	function onDatePick() {
		const input: HTMLInputElement =
			this.closest(".input-group").querySelector(".form-control");

		datepicker.call(input);
	}

	function toggleAdvanced() {
		showAdvanced = !showAdvanced;
	}

	function stopSubmission(e) {
		if (e.key === "Enter") {
			e.preventDefault();
			e.stopPropagation();

			return false;
		}
	}
</script>

<div class="filters">
	<div class="panel panel-default">
		<div class="panel-heading">
			<h3 class="panel-title">Filter Heroes</h3>
		</div>

		<div class="panel-body">
			<div class="filter-row">
				<div class="form-group">
					<label for="heroFilterSearch">Search</label>
					<div class="search-group">
						<input
							id="heroFilterSearch"
							class="form-control search-input"
							bind:value={searchValue}
							on:keydown={stopSubmission}
							on:keyup={stopSubmission}
							on:keypress={stopSubmission}
							on:input={() =>
								searchTimer.Delay(() =>
									onFilter("Search", searchValue)
								)}
						/>
						{#if searchValue !== ""}
							<button
								class="search-clear"
								on:click={() => (
									(searchValue = ""),
									onFilter("Search", searchValue)
								)}>&times;</button
							>
						{/if}
					</div>
				</div>

				<div class="form-group">
					<label for="heroFilterPayGrade">Pay Grade</label>
					<Options
						options={optionsPayGrade}
						id="heroFilterPayGrade"
						label="Select"
						bind:value={payGradeValue}
						on:input={() => onFilter("PayGrade", payGradeValue)}
					/>
				</div>

				<!-- <div class="form-group">
					<label for="heroFilterRank">Rank</label>
					<Options
						options={optionsRank}
						id="heroFilterRank"
						label="Select"
						bind:value={rankValue}
						on:input={() => onFilter("Rank", rankValue)}
					/>
				</div> -->

				<div class="form-group">
					<label for="heroFilterComponent">Component</label>
					<Options
						options={optionsComponent}
						id="heroFilterComponent"
						label="Select"
						bind:value={componentValue}
						on:input={() => onFilter("Component", componentValue)}
					/>
				</div>
			</div>

			<div class="text-center">
				<!-- svelte-ignore a11y-invalid-attribute -->
				<a
					href="#"
					on:click|preventDefault|stopPropagation={toggleAdvanced}
				>
					<small>Advanced Filters</small>
					{#if showAdvanced}
						<i class="fa fa-caret-up" aria-hidden="true" />
					{:else}
						<i class="fa fa-caret-down" aria-hidden="true" />
					{/if}
				</a>
			</div>

			{#if showAdvanced}
				<div class="filter-row advanced-filters">
					<div class="form-group">
						<label for="heroFilterYearOfBirth">Year of Birth</label>

						<div class="input-group">
							<input
								id="heroFilterYearOfBirth"
								class="form-control datepicker-input"
								type="text"
								bind:value={yearBirthValue}
								on:change={() =>
									onFilter("YearOfBirth", yearBirthValue)}
								on:click={datepicker}
							/>
							<div
								class="input-group-addon"
								on:click={onDatePick}
							>
								<i class="fa fa-calendar" aria-hidden="true" />
							</div>
						</div>
					</div>

					<div class="form-group">
						<label for="heroFilterYearOfDeath">Year of Death</label>

						<div class="input-group">
							<input
								id="heroFilterYearOfDeath"
								class="form-control datepicker-input"
								type="text"
								bind:value={yearDeathValue}
								on:change={() =>
									onFilter("YearOfDeath", yearDeathValue)}
								on:click={datepicker}
							/>
							<div
								class="input-group-addon"
								on:click={onDatePick}
							>
								<i class="fa fa-calendar" aria-hidden="true" />
							</div>
						</div>
					</div>

					<div class="form-group">
						<label for="heroFilterYearOfEntry">Year of Entry</label>

						<div class="input-group">
							<input
								id="heroFilterYearOfEntry"
								class="form-control datepicker-input"
								type="text"
								bind:value={yearEntryValue}
								on:change={() =>
									onFilter("YearOfEntry", yearEntryValue)}
								on:click={datepicker}
							/>
							<div
								class="input-group-addon"
								on:click={onDatePick}
							>
								<i class="fa fa-calendar" aria-hidden="true" />
							</div>
						</div>
					</div>

					<div class="form-group">
						<label for="heroFilterYearOfDischarge">
							Year of Discharge
						</label>

						<div class="input-group">
							<input
								id="heroFilterYearOfDischarge"
								class="form-control datepicker-input"
								type="text"
								bind:value={yearDischargeValue}
								on:change={() =>
									onFilter(
										"YearOfDischarge",
										yearDischargeValue
									)}
								on:click={datepicker}
							/>
							<div
								class="input-group-addon"
								on:click={onDatePick}
							>
								<i class="fa fa-calendar" aria-hidden="true" />
							</div>
						</div>
					</div>
				</div>
			{/if}
		</div>
	</div>
</div>

<style>
	.filters {
		position: sticky;
		top: 0;
		z-index: 10;
	}

	.filter-row {
		display: grid;
		gap: 0 30px;
	}

	.advanced-filters {
		margin-top: 15px;
	}

	.input-group-addon {
		cursor: pointer;
	}

	.search-group {
		position: relative;
	}

	.search-clear {
		background: none scroll 0 0 transparent;
		border: 0 none;
		color: red;
		font-size: 16px;
		font-weight: 700;
		height: 20px;
		line-height: 1.1;
		padding: 0;
		position: absolute;
		right: 7px;
		text-align: center;
		top: 9px;
		width: 20px;
	}

	.search-input {
		display: block;
		padding-right: 32px;
		width: 100% !important;
	}

	@media (min-width: 768px) {
		.filter-row {
			grid-template-columns: 1fr 1fr 1fr;
		}

		.advanced-filters {
			grid-template-columns: 1fr 1fr;
		}
	}

	@media (min-width: 992px) {
		.advanced-filters {
			grid-template-columns: 1fr 1fr 1fr 1fr;
		}
	}
</style>
